export const impressumContent = {
  title: "Impresszum",
  serviceProvider: {
    title: "Szolgáltató adatai",
    name: "Szabó Márton",
    email: "burczeckley@gmail.com",
    address: "6000 Kecskemét, Brahms u. 6.",
    activity: "Weboldal fejlesztés és üzemeltetés"
  },
  hostingProvider: {
    title: "Tárhelyszolgáltató adatai",
    name: "Rackhost Zrt.",
    address: "6722 Szeged, Tisza Lajos krt. 41.",
    email: "info@rackhost.hu"
  },
  dataProtection: {
    title: "Adatvédelem",
    content: "Az oldal használata során megadott személyes adatokat bizalmasan kezeljük, harmadik félnek nem adjuk ki. Az adatkezelés az információs önrendelkezési jogról és az információszabadságról szóló 2011. évi CXII. törvény rendelkezéseinek megfelelően történik."
  },
  copyright: {
    title: "Szerzői jogok",
    content: "Az oldalon található minden tartalom, beleértve a szövegeket, képeket, grafikákat, logókat, ikonokat, hang- és videófájlokat, valamint azok elrendezését, a szolgáltató tulajdonát képezik, és a szerzői jog védelme alatt állnak."
  },
  liability: {
    title: "Felelősség korlátozása",
    content: "A weboldalon található információk kizárólag tájékoztató jellegűek. A szolgáltató nem vállal felelősséget a weboldalon található információk pontosságáért, teljességéért vagy használhatóságáért."
  }
};

